export interface SentryScopeLike {
    setTag: (key: string, value: string) => void;
    setExtra: (key: string, value: unknown) => void;
    setExtras: (extras: Record<string, unknown>) => void;
}

export type SentryErrorData = Record<string, unknown> & {
    error?: unknown;
    stackTrace?: string;
    tags?: Record<string, string | number | boolean | null | undefined>;
};

export const enrichSentryScope = (
    scope: SentryScopeLike,
    data?: SentryErrorData,
): void => {
    if (data == null) {
        return;
    }

    const { error: _error, stackTrace, tags, ...rest } = data;

    if (stackTrace != null) {
        scope.setExtra('stackTrace', stackTrace);
    }

    if (tags != null) {
        for (const [key, value] of Object.entries(tags)) {
            if (value != null) {
                scope.setTag(key, String(value));
            }
        }
    }

    if (Object.keys(rest).length > 0) {
        scope.setExtras(rest);
    }
};
